
import { getEnv } from '@common/utilities/env';

export const getUIBaseURL = (): string => {
  const env = getEnv('REACT_APP_FEATURE_FLAG_ENV');

  const isProd = env === 'prod';

  let baseURL: string;

  if (isProd) {
    baseURL = 'https://go.escoffierglobal.com';
  } else {
    // Could be dev or test. If it's local host will stay as dev
    baseURL = `https://${env}.go.escoffierglobal.com`;
  }
  return baseURL;
};
